<template>
    <div class="recent-orders" style="z-index: 100000">
        <h2>Histórico Operacional Services</h2> 

        <button id="minimize" v-on:click="minimize" style="top:0px; right:0px; position:absolute; background: var(--color-background); border-radius: 10px;border:none;"><span class="material-icons-sharp" style="color: var(--color-dark);">remove</span></button>   
        <button id="maximize" v-on:click="maximize" style="top:0px; right:25px; position:absolute; background: var(--color-background); border-radius: 10px;border:none;"><span class="material-icons-sharp" style="color: var(--color-dark);">add</span></button>           

        <table v-if="isHidden==false" id="tabela">
            <thead>
                <tr>
                    <th>Icone</th>
                    <th>Hora</th>
                    <th>Prefixo</th>
                    <th>Evento</th>
                    <th>Cliente</th>
                    <th></th>
                </tr>
            </thead>
            <tbody >
                <tr v-for="event in dadosTabela" :key="event.id">
                    <td>-</td>
                    <td> {{ event.hora.split('T')[1]  }}</td>
                    <td>{{ event.prefixo }}</td>
                    <td>{{ event.evento }}</td>
                    <td>{{ event.cliente }}</td>
                    <td></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
  
<script>
export default {
    props: ["events"],

    data(){
        return{
            isHidden:false
        };
    },

    computed: {
        dadosTabela: function () {
            return this.events;
        },
    },

    watch: {},

    methods: {
        mountTable() { },

        minimize(){
            this.isHidden = true
        },

        maximize(){
            this.isHidden = false
        }
    },

    mounted() { },
};
</script>


<style lang="scss" scoped>
.recent-orders {
    opacity: 0.8;
    position: absolute;
    background: var(--color-background);
    border-radius: 10px;
    width: 450px;
    bottom: 5px;
    box-shadow: 0 0 40px -10px rgba(0, 0, 0, .8);
    transition: all 300ms ease;
    margin-left:5px;
}

.recent-orders h2 {
    margin-bottom: 0.8rem;
    font-family: poppins, sans-serif;
    font-size: 20px;
    color: var(--color-primary);
    text-align: center;
    padding: 8px;
}

.recent-orders table {
    background: var(--color-white);
    width: 100%;
    color: var(--color-dark);
    background: var(--color-background);
    border-radius: var(--card-border-radius);
    padding: var(--card-padding);
    text-align: left;
    box-shadow: var(--box-shadow);
    transition: all 300ms ease;
}

.recent-orders table:hover {
    box-shadow: none;
}

table tbody td {
    height: 2.8rem;
    border-bottom: 1px solid var(--color-light);
}

// table tbody tr:last-child {
//     border: none;
// }

// .recent-orders a {
//     text-align: center;
//     display: block;
//     margin: 1rem auto;
//     color: var(--color-primary);
// }
</style>





// WEBPACK FOOTER //
// src/views/monitoramento/historico-operacional.vue